<da-drawer-animation-wrapper
  (animationDone)="drawerAnimationDone()"
  #drawerWrapper
>
  <da-drawer-header
    [drawer]="drawerState()"
    (close)="drawerClose($event)"
  ></da-drawer-header>

  <div class="tw-flex-1 tw-overflow-y-auto tw-bg-neutral-50 tw-p-4">
    <ng-template #contentHost></ng-template>

    @if (!contentComponent()) {
      <div>No Component Provided</div>
    }
  </div>

  <da-drawer-footer
    [drawer]="drawerState()"
    (close)="drawerClose($event)"
  ></da-drawer-footer>
</da-drawer-animation-wrapper>
